import { useState } from "react";

interface BanderaProps {
  grupo?: string;
  nombre: string;
  alt: string;
  className?: string;
  size?: number;
}

const EXTENSIONS = ["png", "webp", "jpg"];

const Bandera = ({
  grupo,
  nombre,
  alt,
  className = "bandera",
  size,
}: BanderaProps) => {
  const baseUrl = "/banderas";

  const buildSrc = (ext: string, withGroup: boolean) =>
    withGroup && grupo
      ? `${baseUrl}/${grupo}/${nombre}.${ext}`
      : `${baseUrl}/${nombre}.${ext}`;

  const [extIndex, setExtIndex] = useState(0);
  const [withGroup, setWithGroup] = useState(true);
  const [src, setSrc] = useState(buildSrc(EXTENSIONS[0], true));

  const handleError = () => {
    // 1️⃣ probar otra extensión
    if (extIndex < EXTENSIONS.length - 1) {
      const next = extIndex + 1;
      setExtIndex(next);
      setSrc(buildSrc(EXTENSIONS[next], withGroup));
      return;
    }

    // 2️⃣ quitar grupo y reiniciar extensiones
    if (withGroup) {
      setWithGroup(false);
      setExtIndex(0);
      setSrc(buildSrc(EXTENSIONS[0], false));
    }
  };

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      width={size}
      height={size}
      onError={handleError}
    />
  );
};

export default Bandera;
